module.exports = {
	"articleTitle1": "2 Chainz, Lil Yachty and Desiigner coming to Crisler Center for ...",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Crisler Center",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/sanders-makes-stop-ann-arbor-day-michigan-primary",
	"articleSnippet1": "Mar 20, 2017 ... MUSIC Matters' SpringFest will be hosting headliners 2 Chainz, Lil Yachty and \nDesiigner at the Crisler Center for the organization's ...",
	"articleSnippet2": "Mar 7, 2016 ... Bernie Sanders (D-Vt.) filled Crisler Center Monday for the candidate's first visit to \nAnn Arbor: a “Get Out To Vote” rally the day before the ...",
	"totalMisc": 0,
	"articleTitle2": "Sanders touts free college tuition at Crisler Center ",
	"address": "333 E Stadium Blvd, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170214/johnbeilein.jpg?itok=-Bmytk3U",
			"author": "File Photo",
			"caption": "Michigan coach John Beilein and the Wolverines notched two crucial wins against Indiana and Michigan State in the past week."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170208/eaa.BKC_.vsMSU_.2.7.17.4.jpg?itok=8cb-4RJg",
			"author": "Evan Aaron",
			"caption": "Senior guard Derrick Walton Jr. willed his team to victory with 20 points, eight assists and five rebounds."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160412/amf3.online.jpg?itok=JT6CL5mL",
			"author": "Allison Farrand",
			"caption": "An in-camera multiple exposure of University of Michigan gymnast Lauren Marinez competing in a meet at the Crisler Center in Ann Arbor, Michigan on January 16, 2016."
		}
	],
	"position": {
		"lat": 42.265,
		"lng": -83.7467
	},
	"tips": [],
	"bathroomrating": [
		{
			"rating": 3,
			"bathroom": "All Bathrooms"
		}
	],
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/crislercenter.json
// module id = 858
// module chunks = 0